import React from 'react';
import './CancelButton.css';

// Pale salmon fill with deep salmon text and a hover-darken state — used by
// every Cancel action, forms and dialogs alike, so both the colour and the
// hover behaviour only have to change in one place. `style` still merges on top for one-off layout
// tweaks (e.g. marginLeft next to a Save button).
const CancelButton = React.forwardRef(({ onClick, disabled, style, children, ...rest }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className="cancel-button"
      onClick={onClick}
      disabled={disabled}
      style={style}
      {...rest}
    >
      {children || 'Cancel'}
    </button>
  );
});

export default CancelButton;
